import { ExtendedAccountColumns, ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import {
    collectOrgIdsForAnyOrgPermission,
    requireAnySystemPermission,
} from '@juvare/contact-management/backend/features/permissions/shared';
import { ReadonlyStorageContext } from '@juvare/platform-app/App';
import { UserState } from '@juvare/platform-sdk-react/types';

interface AuthorizedManageAccountsParams {
    userState: UserState;
    accountIds: string[];
}

export function authorizedManageAccounts(
    context: ReadonlyStorageContext,
    { userState, accountIds }: AuthorizedManageAccountsParams,
): boolean {
    if (requireAnySystemPermission(userState, 'manage-accounts')) {
        return true;
    }

    const accountStorage = context.storage<ExtendedAccountData, ExtendedAccountColumns>(accountEntityName);
    const accounts = accountStorage.listColumns(
        {
            filter: [
                {
                    id: accountIds,
                    op: 'in',
                },
            ],
        },
        'orgMembership',
        'systemRole',
        'systemStatus',
    ).rows;

    if (accounts.some((account) => account.columns.systemStatus === 'deleted')) {
        return false;
    }

    const manageableOrganizationIds = collectOrgIdsForAnyOrgPermission(userState, 'manage-members');
    const canManageAccountsByOrgPermission = accounts.every((account) =>
        account.columns.orgMembership.some((orgId) => manageableOrganizationIds.includes(orgId)),
    );

    return accounts.length > 0 && canManageAccountsByOrgPermission;
}
